export default {
  pages: {
    products: {
      tape: {
        disclaimer3d: "*非完整结构，后续或将进行封装。",
      },
    },
  },
  advantages: {
    title: "核心优势",
    content: "",
    list: [
      {
        title: "技术、工艺",
        image: '/images/products/技术、工艺.jpg',
        url: "technology",
      },
      {
        title: "自主装备",
        image: '/images/products/自主装备.jpg',
        url: "selfequipped",
      },
      {
        title: "质量控制",
        image: '/images/products/质量控制.png',
        url: "qualitycontrol",
      },
      {
        title: "交付能力",
        image: '/images/products/交付能力.jpg',
        url: "deliverycapability",
      },
    ],
    technology: {
      title: "技术、工艺",
      introduction: {
        cases: [
          {
            title: "超快脉冲激光沉积技术",
            content:
              "上海超导在多年研发和生产经验的积淀下，形成一条基于脉冲激光沉积（PLD）镀膜方法的超快速超导薄膜制备技术。该技术采用高温原位应力控制和多元成分协同优化等独特的工艺创新，突破了传统脉冲激光沉积技术镀膜速度慢、样本空间小等瓶颈，既实现了超快速成膜，又保留了PLD技术原有的镀膜质量高、超导临界电流性能优越等优势，解决了物理法生产效率低的难题，具有生产速度快、成品率高、成本低等特点，适用于大批量规模化工业生产。经过上海超导多年批量化生产检验，其高质量高温超导薄膜沉积速度达到了100nm/s，为同类技术的3倍以上。",
          },
          {
            title: "超大离子源快速IBAD镀膜技术",
            content:
              "离子束辅助沉积（IBAD）技术是制备缓冲层的关键，缓冲层可为超导层的生长提供立方织构。上海超导根据多年研发经验，创新采用一种先进的超大离子源快速IBAD镀膜技术，在增加离子束密度的同时，可使其能量和密度更加均匀，将缓冲层的镀膜效率提升3倍以上，为后续制备高性能、高稳定性的超导层的基础。",
          },
          {
            title: "精密定制的金属基带技术",
            content:
              "上海超导持续研发投入，始终坚定不移的探索基带国产化道路，成功开发出紧密定制的金属基带技术，解决了产业链中材料供应“卡脖子”难题。国产基带具有可定制化、厚度精密可控、纳米级平整等特点，适用于超薄、超硬等定制化参数需求。超薄基带厚度为30μm，超硬基带拉伸应力超过700Mpa。",
          },
          {
            title: "非接触式低温瞬冷连续封装技术",
            content:
              "超导带材的连续封装技术是保证超导带材在实际应用工况下的机械性能稳定的关键工艺，也是超导带材抗击过流冲击的关键指标。上海超导形成了一套基于快速锡渣处理、非接触式低温瞬冷和被动式自动收料等关键工艺的连续封装技术（包括紫铜、黄铜、不锈钢等多种封装材料），解决了不锈钢封装、环氧浸渍衰减、带材过流烧断、带材开裂等长期困扰业界的难题，使得二代高温超导带材的电学力学性能有了大幅度的加强，能够承受100ms工频高达2400A冲击电流、不发生电流退降，77K下拉伸应力超过700MPa。",
          },
          {
            title: "低温强场高性能的磁通钉扎技术",
            content:
              "上海超导经过系统地研究及产业化改良，解决了在快速镀膜过程中无法引入有效的钉扎中心的难题，有效抑制了磁场对电流衰减，大幅提升了产品低温强场性能及产能，实现了带材低温强场特性达到1600A(4.2K,10T)的国际领先水平，为超导磁体技术、大科学装置等应用的建设奠定了重要的核心材料基础，将推动中国高温超导战略产业发展。",
          },
        ],
      },
    },
    selfequipped: {
      title: "自主装备",
      introduction: {
        cases: [
          {
            title: "全套生产装备自主研制技术",
            content:
              "上海超导经过十余年技术沉淀，百余次研发改良，实现了全套生产装备包括脉冲激光沉积设备、离子束辅助沉积设备等设备知识产权全自主，达到了高品质和高产量的良好结合，实现了产品工艺自主可控，打破国外垄断、填补了第二代高温超导带材国内空白。 ",
          },
          {
            title: "辐射辅助传导加热技术",
            content:
              "高效稳定的加热技术是脉冲激光沉积设备的关键核心，更是决定高温超导带材工业化生产的重要基础。上海超导结合多年生产和研发经验，创新研发了一种适用于卷对卷连续化带材生产的辐射辅助传导加热技术，可保证在高速走带情况下将带材快速升温至目标温度，同时可形成更大的均温区，显著提高了加热效率，确保镀膜过程的顺利进行。",
          },
        ],
      },
    },
    qualitycontrol: {
      title: "质量控制",
      introduction: {
        cases: [
          {
            title: "过程检验",
            content: `1）采用原子力显微镜（AFM）对电抛后的基带、隔离层的表面粗糙度进行检验。

2）采用X射线衍射仪对涂层的物相、结晶情况及薄膜面内面外织构度、薄膜应力情况等进行测定，以保证生产中各层薄膜质量符合制备工艺要求。

3）采用扫描电子显微镜（SEM）对各涂层的表面形貌和分切切口进行观察。

4）采用探针式轮廓仪对各涂层的厚度进行检测。`,
          },
          {
            title: "出厂检验",
            content: `1）采用MCorder高温超导带材临界电流均匀性测试系统对超导长带的电流均匀性进行测定。

2）采用PPMS综合物性测量系统对长带端样进行低温高场性能测试，4.2K 0-6T（全检）4.2K 0-12T（抽检）。

3）分别用倒带机、千分尺、游标卡尺对带材的几何尺寸（长度、厚度、宽度）进行测量。`,
          },
        ],
      },
    },
    deliverycapability: {
      title: "交付能力",
      introduction: {
        content: "上海超导已开启全面扩产计划，以全方位提升产能和带材交付能力。2024年底一期扩产项目顺利完成，产能达2000km/年；目前二期扩产项目顺利推进中，建成后产能将达4000km/年；三期扩产项目已完成备案，建成后上海超导总产能将达20000km/年。\n\n未来，上海超导将继续坚持技术创新，进一步提升供货能力和产品性能，与客户共同推进聚变能源等超导应用技术的突破和发展。"
      }
    },
  },
  performance: {
    title: "带材性能介绍",
    introduction: {
      cases: [
        {
          title: "角度依赖性测试",
          content:
            "RRI测试了我司超导带材在15-90K、0-7T、不同角度下的Ic值，测试结果表明，上海超导的带材在高场磁体应用方面具有显著优势。",
          pcontent: "测试时间：2022.2",
        },
        {
          title: "工程电流密度：丹麦技术大学",
          content:
            "丹麦技术大学测试了我司主流量产超导带材在极高磁场和低温下的工程电流密度，测试表明，上海超导的带材产品具有较高的工程电流密度以及高机械强度，JE(4.2K, 10T)达2000A/mm2。",
          pcontent:
            "来源：A C Wulff, et al. Multifilamentary coated conductors for ultra-high magnetic field applications. Superconductor Science and Technology, 2021(34)",
        },
        {
          title: "力学性能测试：基带单轴拉伸测试",
          content:
            "常温下，采用拉伸试验方法测试基带的屈服强度，屈服强度达1526Mpa。",
          pcontent: "测试时间：2023.6",
        },
        {
          title: "低温高场性能表格",
        },
      ],
    },
  },
  service: {
    title: "技术服务",
    introduction: {
      content: "在批量提供多种规格高温超导带材的同时，上海超导进一步拓展服务范围，推出定制化服务。定制化服务可更好地满足不同客户在特定应用场景下的个性化需求，通过精准定制产品规格、性能参数等，为科研、工业等领域提供更具针对性的超导带材和配套服务。我们拥有专业的技术团队，能够为客户提供从方案设计到产品交付的全流程技术支持。",
      cases: [
        {
          title: "定制化极高性能超导带材",
          content: `上海超导坚持研发突破带材极限性能，保持国际领先地位，并逐步将定制化产品转化为批量产品，供应各领域应用研发突破世界纪录。

            现有定制化极高性能超导带材性能为：强场下，载流密度达到3800A/mm2（4.2 K, 12 T，日本KEK机构测试结果）。`,
          pcontent:
            "来源：Superconducting properties of commercial REBCO-coated conductors with artificial pinning centers (Kiyosumi Tsuchiya et al 2021 Supercond. Sci. Technol. 34 105005)",
        },
        {
          title: "定制化激光分切超导带材",
          content:
            "高度可控激光分切技术是一种先进的高温超导材料分切技术，具有高分切精度、高分切质量、高效可控等优点，可保证带材分切边缘的整体平整度和光滑度，有效控制高温超导带材分切裂纹扩展。",
        },
        {
          title: "定制化铜银合金封装超导带材",
          content:
            "铜银合金封装技术是一种采用铜银合金对超导带材进行封装的技术，在略微降低超导带材电性能的基础上，可显著增强超导带材的力学性能。",
        },
      ],
    },
  },
  tape: {
    title: "第二代高温超导带材",
    introduction: {
      title: "简介",
      content:
        "上海超导基于物理气相沉积法制备的ReBCO带材具有全球领先的低温高场电性能，一流的自场电流密度、优异的磁体绕制性能、极低的交流损耗，可广泛应用于电力、交通、能源、医疗、高能物理等各个领域。",
      cases: [
        { title: "带材核心结构" },
        { title: "产品规格" },
      ],
    },
    disclaimer3d: "*非完整结构，后续或将进行封装。",
  },
};
